import React from 'react';
import { IoIosArrowForward } from 'react-icons/io';

import { ItemGroupProps } from 'types/ItemGroupProps';
import * as S from './styles';

interface RedirectTitleProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function RedirectTitle({
  data,
  phoneWidth,
}: RedirectTitleProps) {
  function returnRightCompByType() {
    switch (data.type) {
      case 'default':
        return (
          <S.defaultType>
            <p>{data.name || 'No name'} </p>
            <b>{data?.items[0]?.name || 'No name'} </b>
          </S.defaultType>
        );

      case 'with-image':
        return (
          <S.imageType>
            <div>
              {data?.items[0]?.file?.url &&
                data?.items[0]?.image_align === 'left' && (
                  <img src={data?.items[0]?.file?.url} alt={data.name} />
                )}
              <p>{data.name || 'No name'} </p>
              {data?.items[0]?.file?.url &&
                data?.items[0]?.image_align === 'right' && (
                  <img src={data?.items[0]?.file?.url} alt={data.name} />
                )}
            </div>
            <IoIosArrowForward />
          </S.imageType>
        );

      case 'with-search':
        return (
          <S.searchType>
            {data?.items[0]?.file?.url && (
              <img src={data?.items[0]?.file?.url} alt={data.name} />
            )}
            <p>{data.name || 'No name'} </p>
          </S.searchType>
        );

      default:
        return <p>Tipo inesperado</p>;
    }
  }

  return <S.container>{returnRightCompByType()}</S.container>;
}
